/* import __COLOCATED_TEMPLATE__ from './status.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import Component from '@glimmer/component';
import type SyncSourceWrapper from 'embercom/models/knowledge-hub/sync-source-wrapper';
import { ContentSourceStatusType } from '../content';

interface Args {
  source: SyncSourceWrapper;
  publishedContentCount: number;
  isEligibleForChatbot: boolean;
  isEligibleForCopilot: boolean;
  usage: {
    agent: number;
    all: number;
    copilot: number;
  };
  statusText?: string;
  tooltipText?: string;
  hideTooltipIcon?: boolean;
}

export default class Status extends Component<Args> {
  contentSourceStatusType = ContentSourceStatusType;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Knowledge::ExternalContent::Status': typeof Status;
  }
}
